import Moment from 'moment';
import { extendMoment } from 'moment-range';
import isEmpty from 'lodash.isempty';

const moment = extendMoment(Moment);

export function createFromMysql(mysql_string)
{ 
   var t, result = null;

   if( typeof mysql_string === 'string' )
   {
      t = mysql_string.split(/[- :]/);

      //when t[3], t[4] and t[5] are missing they defaults to zero
      result = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0));          
      //console.log(`result:`, result);
   }

   return result;   
}
export function convertDaysOfWeek(record){
    const currentDaysOfWeek = !isEmpty(record.dayofweek) && !Array.isArray(record.dayofweek) ? record.dayofweek.split(',') : (Array.isArray(record.dayofweek) ? record.dayofweek : null)
    //console.log(`currentDaysOfWeek:`, currentDaysOfWeek)
    return currentDaysOfWeek
}
// export function formatTime(time){

// }
//https://github.com/rotaready/moment-range/issues/159
// function subtractRanges(longRanges, shortRanges)
//   {
//     // Always return an array
//     if(shortRanges.length === 0)
//       return longRanges.hasOwnProperty("length")
//         ? longRanges
//         : [longRanges];

//     // Result is empty range
//     if(longRanges.length === 0)
//       return [];

//     if(!longRanges.hasOwnProperty("length"))
//       longRanges = [longRanges];

//     for(let long in longRanges)
//     {
//       for(let short in shortRanges)
//       {
//         longRanges[long] = longRanges[long].subtract(shortRanges[short])
//         if(longRanges[long].length === 0)
//         {
//           // Subtracted an entire range, remove it from list
//           longRanges.splice(long, 1);
//           shortRanges.splice(0, short);
//           return this.subtractRanges(longRanges, shortRanges);
//         }
//         else if(longRanges[long].length === 1)
//         {
//           // No subtraction made, but .subtract always returns arrays
//           longRanges[long] = longRanges[long][0];
//         }
//         else
//         {
//           // Successfully subtracted a subrange, flatten and recurse again
//           const flat = [].concat(...longRanges);
//           shortRanges.splice(0, short);
//           return this.subtractRanges(flat, shortRanges);
//         }
//       }
//     }
//     return longRanges;
//   }
//let day = moment("00:00:00", "HH:mm:ss").range("day");
//let ranges = [moment("10:00:00", "HH:mm:ss").range("hour"), moment("16:00:00", "HH:mm:ss").range("hour")];
//subtractRanges(day, ranges);

const isAtArrival = (date, fromd, tod) => {
	if (!fromd)
		return false
	return date.isSame(fromd, 'day')
}

const isAtDeparture = (date, fromd, tod) => {
	if (!tod)
		return false
	return date.isSame(tod, 'day')
}

const isEveryDay = (date, fromd, tod) => {
	if (!fromd || !tod)
		return false
	return date.isBetween(fromd, tod, 'day', '[]')
}

const isEveryDayExceptArrival = (date, fromd, tod) => {
	if (!fromd || !tod)
		return false
	//return date.isBetween(fromd, tod, 'day', '(]')
	return date.isBetween(fromd, tod, 'day', '()')
}

const isEveryDayExceptDeparture = (date, fromd, tod) => {
	if (!fromd || !tod)
		return false
	return date.isBetween(fromd, tod, 'day', '[)')
}
const isEveryDayExceptArrivalDeparture = (date, fromd, tod) => {
	if (!fromd || !tod)
		return false
	return date.isBetween(fromd, tod, 'day', '()')
}

const isEveryXDays = (date, fromd, tod, num_jump) => {
	//console.log(`isEveryXDays:`, date, fromd, tod, num_jump);
	if (!fromd || !tod || !num_jump)
        return false
        
    if(date.isSame(moment(fromd), 'day')){
        return false;
    }

	let day = moment(fromd)
	//while (day.isSameOrBefore(tod, 'day')) {
	while (day.isBefore(tod, 'day')) {
		if (date.isSame(day, 'day'))
			return true;
		day.add(num_jump, 'days')
	}
	return false
}

export function isActive(type, date, fromd, tod) {
	switch (type) {
		case 'at_arrival':
			return isAtArrival(date, fromd, tod);
		case 'at_departure':
			return isAtDeparture(date, fromd, tod);
		case 'every_day':
			return isEveryDay(date, fromd, tod);
		case 'every_day_except_arrival':
			return isEveryDayExceptArrival(date, fromd, tod);
		case 'every_day_except_departure':
			return isEveryDayExceptDeparture(date, fromd, tod);
        case 'every_day_except_arrival_departure':
			return isEveryDayExceptArrivalDeparture(date, fromd, tod);            
		case 'every_2_days':
			return isEveryXDays(date, fromd, tod, 2);
		case 'every_3_days':
			return isEveryXDays(date, fromd, tod, 3);
		case 'every_4_days':
			return isEveryXDays(date, fromd, tod, 4);
		case 'every_5_days':
			return isEveryXDays(date, fromd, tod, 5);
        case 'every_6_days':
			return isEveryXDays(date, fromd, tod, 6);
        case 'every_7_days':
			return isEveryXDays(date, fromd, tod, 7);
		default:
			return false
	}
}

/**
 * Calculates and returns date parameters depending on the operational period of a property
 * 
 * @param {*} defaultParams parameters object with additional params
 * @param {Object} property used for operation_open_from...
 * @returns {Object} new params with reassigned fromd, tod depending on operating period
 */
export function calculateOperatingPeriod(defaultParams, property) {
	// console.log(`property:`, property)
	const d = new Date();
	const today = moment();
	let params = Object.assign({
		fromd: moment().format('YYYY-MM-DD'),
		tod: moment().add(1, 'year').format('YYYY-MM-DD'),
	}, defaultParams);
	//console.log(`params:`, params);

	if (property && property.operation_type === 'seasonal') {
		let from_date = null;
		let to_date = null;
		let from_year = null;
		let to_year = null;
		if (property.operation_open_from_month < property.operation_open_to_month) {
			from_year = d.getFullYear();
			to_year = from_year;
		} else {
			from_year = d.getFullYear();
			to_year = d.getFullYear() + 1;
		}
		from_date = moment(`${from_year}-${String(property.operation_open_from_month).padStart(2, '0')}-${String(property.operation_open_from_day).padStart(2, '0')}`);
		to_date = moment(`${to_year}-${String(property.operation_open_to_month).padStart(2, '0')}-${String(property.operation_open_to_day).padStart(2, '0')}`);
		const operation_range = moment.range(from_date, to_date).contains(today) || today.isSameOrBefore(to_date) ? moment.range(from_date, to_date) : moment.range(from_date.clone().add(1, 'year'), to_date.clone().add(1, 'year'));
		//console.log(`operation_range:`, operation_range);
		params = Object.assign(params, {
			fromd: operation_range.start.format('YYYY-MM-DD'),
			tod: operation_range.end.format('YYYY-MM-DD'),
		});
	}
	return params;
}

/**
 * Calculates and returns calendar date depending on operating
 * 
 * @param {*} defaultParams parameters object with additional params
 * @param {Object} property used for operation_open_from...
 * @returns {moment} calendarFrom date (moment object)
 */
export function getCalendarDate(defaultParams, property) {
	if (!property) {
		property = localStorage.activeProperty ? JSON.parse(localStorage.activeProperty) : null;
	}

	const d = new Date();
	const today = defaultParams && defaultParams.fromd ? moment(defaultParams.fromd) : (property && property.settings && property.settings.start_calendar_from_today ? moment() : moment().subtract(2, 'days'));

	if (property && property.operation_type === 'seasonal') {
		let from_date = null;
		let to_date = null;
		let from_year = null;
		let to_year = null;
		if (property.operation_open_from_month < property.operation_open_to_month) {
			from_year = d.getFullYear();
			to_year = from_year;
		} else {
			from_year = d.getFullYear();
			to_year = d.getFullYear() + 1;
		}
		from_date = moment(`${from_year}-${String(property.operation_open_from_month).padStart(2, '0')}-${String(property.operation_open_from_day).padStart(2, '0')}`);
		to_date = moment(`${to_year}-${String(property.operation_open_to_month).padStart(2, '0')}-${String(property.operation_open_to_day).padStart(2, '0')}`);
		const operation_range = moment.range(from_date, to_date).contains(today) || today.isSameOrBefore(to_date) ? moment.range(from_date, to_date) : moment.range(from_date.clone().add(1, 'year'), to_date.clone().add(1, 'year'));
		if (today.within(operation_range)) return today;
		return operation_range.start;
	}
	return today;
}

/**
 * Returns true if pending accommodation
 * 1. Optional accommodation but not optional reservation & past expiration date
 * 2. Should have checked in
 * 3. Should have checked out
 * 
 * @param {Object} record accommodation to check
 * @param {string, moment} date night audit date
 * @returns {Boolean} true if accommodation is pending in night audit, false otherwise
 */
export function checkPendingAccommodation(record, date) {
	const currentDate = moment(date);
	return (
		(record.reservation_status_id === 2
			&& record.reservations.reservation_status_id !== 2
			&& currentDate.isSameOrAfter(record.reservations.unconfirmedExpiry))
		|| ([1, 2].includes(record.reservation_status_id)
			&& currentDate.isSameOrAfter(record.fromd))
		|| (record.reservation_status_id === 3
			&& currentDate.isSameOrAfter(record.tod))
	)
}

/**
 * Returns true if pending reservation
 * 1. Optional reservation & past expiration date
 * 
 * @param {Object} record reservation to check
 * @param {string, moment} date night audit date
 * @returns {Boolean} true if accommodation is pending in night audit, false otherwise
 */
export function checkPendingReservation(record, date) {
	const currentDate = moment(date);
	return (record.reservation_status_id === 2 && currentDate.isSameOrAfter(record.unconfirmedExpiry))
}